import { ConfigProvider } from 'antd';
import esES from 'antd/es/locale/es_ES';
import moment from 'moment';
import 'moment/locale/es';
import 'pdfjs-dist/build/pdf.worker.entry';
import React from 'react';
import { render } from 'react-snapshot';
import App from './App';
import { CONFIG, setConfig } from './constants';
import './i18n';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { initInstance } from './utils/axios';

const validateMessages = {
  // eslint-disable-next-line no-template-curly-in-string
  required: '${label} es un campo requerido'
};

moment.locale('es');

fetch('/config.json', {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})
  .then((response) => {
    return response.json();
  })
  .then((configJson) => {
    setConfig(configJson);
    initInstance(CONFIG.URL_BASE);
    ConfigProvider.config({});
    render(
      <ConfigProvider
        locale={esES}
        theme={{
          token: {
            colorPrimary: CONFIG.COLOR_PRIMARY
          },
          components: {
            Layout: {
              colorBgHeader: CONFIG.COLOR_PRIMARY
            },
            Menu: {
              colorItemBg: CONFIG.COLOR_PRIMARY,
              colorSubItemBg: CONFIG.COLOR_PRIMARY
            },
            Button: {
              colorLink: CONFIG.COLOR_PRIMARY,
              colorLinkHover: CONFIG.COLOR_PRIMARY
            },
            Result: {
              colorInfo: CONFIG.COLOR_PRIMARY
            }
          }
        }}
        form={{ validateMessages }}
      >
        <App />
      </ConfigProvider>,
      document.getElementById('root')
    );
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
